import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

export const guestSurveyContextShape = {
  reservationId: z.string().uuid(),
  propertyName: z.string().nullable(),
  checkoutDate: z.iso.datetime({ offset: true }),
  reportsTra: z.boolean(),
  reportsSire: z.boolean(),
}

export const guestSurveyLinkShape = {
  token: z.string(),
  url: z.string(),
}

export const guestPinSetupInputShape = {
  token: z.string(),
  instanceId: z.string().uuid(),
  pin: z.string(),
  email: z.string(),
}

export const guestPinSetupShape = {
  email: z.email(),
  emailSent: z.boolean(),
}

export type GuestSurveyContext = GetInferredFromRaw<typeof guestSurveyContextShape>
export type GuestSurveyLink = GetInferredFromRaw<typeof guestSurveyLinkShape>
export type GuestPinSetup = GetInferredFromRaw<typeof guestPinSetupShape>
